import DM from '@ott/utility-date';

type Flight = {
  price: number;
  departDate: string;
  returnDate: string;
  currency: string;
};

type HeatmapPrices = {
  [date: string]: {
    price: number;
    range: number;
  };
};

type Heatmap = {
  currency: string;
  prices: HeatmapPrices;
  min: number;
  mid: number;
  max: number;
};

function closest(num: number, flights: Flight[]): number {
  let curr: number = flights[0].price;
  let diff: number = Math.abs(num - curr);

  for (let i = 0; i < flights.length; i += 1) {
    const { price } = flights[i];

    const newdiff: number = Math.abs(num - price);
    if (newdiff < diff) {
      diff = newdiff;
      curr = price;
    }
  }

  return curr;
}

function ranges(
  min: number,
  mid: number,
  max: number,
  flights: Flight[],
  departureOrReturnDate?: string
) {
  const normalizedDepartureOrReturnDate = departureOrReturnDate
    ? DM.stringifyDate(departureOrReturnDate)
    : null;
  // ranges { lower | middle | higher }
  const lower = min + (mid - min) / 2;
  const higher = max - (max - mid) / 2;

  const prices: HeatmapPrices = {};
  for (let i = 0; i < flights.length; i += 1) {
    const { price, departDate, returnDate } = flights[i];
    const isOneDayTrip: boolean = departDate === returnDate;

    let range: number;
    if (price >= min && price < lower) {
      range = 0;
    } else if (price >= lower && price < higher) {
      range = 1;
    } else {
      range = 2;
    }

    const shouldAddPrice = (date: string): boolean =>
      normalizedDepartureOrReturnDate !== date || isOneDayTrip;
    if (departureOrReturnDate && shouldAddPrice(returnDate)) {
      prices[returnDate] = {
        price,
        range,
      };
    }
    if (shouldAddPrice(departDate)) {
      prices[departDate] = {
        price,
        range,
      };
    }
  }

  return prices;
}

// Это правило будет удалено из eslint конфига.
// eslint-disable-next-line import/prefer-default-export
export function prepareHeatmap(
  flights: Flight[],
  departureOrReturnDate: string
): Heatmap | undefined {
  if (!flights || !flights.length) {
    return undefined;
  }

  let min = Infinity;
  let max = -Infinity;

  for (let i = 0; i < flights.length; i += 1) {
    const { price } = flights[i];

    if (min > price) {
      min = price;
    }

    if (price > max) {
      max = price;
    }
  }

  const average = (min + max) / 2;
  const mid = closest(average, flights);

  return {
    currency: flights[0].currency,
    prices: ranges(min, mid, max, flights, departureOrReturnDate),
    min,
    mid,
    max,
  };
}
